import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TodoEmptyStateIcon} from 'shells/icon/svg/todo-empty-state-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TodoErrorStateIcon} from 'shells/icon/svg/todo-error-state-icon';
import {TodoListItem} from 'shells/list-item/todo-list-item';
import {ListView} from 'shells/list-view/list-view';
import {SidebarSpecialState} from 'shells/sidebar-special-state/sidebar-special-state';

type Props = {
    isLoading: boolean;
    hasError: boolean;
    refetchTodos: () => any;
    todos: any[];
};

export class SidebarCalendarTodos extends React.PureComponent<Props> {
    render() {
        return (
            <ListView
                isLoading={this.props.isLoading}
                collection={this.props.todos}
                renderRow={this.renderTodoRow}
                loadingState={{
                    customComponent: (
                        <div style={{textAlign: 'center', paddingTop: 32}}>
                            <LoadingIcon />
                        </div>
                    ),
                }}
                specialStates={[
                    {
                        shouldRender: () => this.props.hasError,
                        component: (
                            <SidebarSpecialState
                                iconComponent={<TodoErrorStateIcon size={70} />}
                                headerText='Whoops!'
                                subheaderText={"That didn't quite go to plan"}
                                primaryCTA={{
                                    ctaText: 'Try again',
                                    onClick: this.props.refetchTodos,
                                }}
                            />
                        ),
                    },
                    {
                        shouldRender: () => this.props.todos.length === 0,
                        component: (
                            <SidebarSpecialState
                                headerText='No tasks were found'
                                subheaderText='Tasks are a lightweight way to remind yourself of things you need to do.'
                                iconComponent={<TodoEmptyStateIcon size={70} />}
                            />
                        ),
                    },
                ]}
            />
        );
    }

    renderTodoRow = (todo: any) => {
        return (
            <TodoListItem
                key={todo.id}
                todo={todo}
                hasBorders={true}
                hideActionMenu={true}
                hasActions={false}
            />
        );
    };
}
